export default "__VITE_ASSET__IOLRMDqO__"